import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../axiosInterceptor";
import { toast } from "react-toastify";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const Login = () => {
  const navigator = useNavigate();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    email: "",
    password: "",
  });
  const [errors, setErrors] = useState({
    email: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let hasErrors = false;

    if (!data.email.trim()) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        email: "Email is required",
      }));
      hasErrors = true;
    } else if (!/\S+@\S+\.\S+/.test(data.email)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        email: "Please enter a valid email address",
      }));
      hasErrors = true;
    }

    if (!data.password.trim()) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        password: "Password is required",
      }));
      hasErrors = true;
    } else if (data.password.length < 6) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        password: "Password must be at least 6 characters long",
      }));
      hasErrors = true;
    }

    if (hasErrors) {
      return;
    }
    setLoading(true);
    try {
      const response = await axiosInstance.post(`admin/login`, data);
      localStorage.setItem("adminId", response.data.admin._id);
      localStorage.setItem("corporateadminToken", response.data.authToken);
      localStorage.setItem("fullName", response.data.admin.fullName);
      localStorage.setItem("email", response.data.admin.email);
      if (response.status === 200) {
        toast.success(response.data.message);
        navigator("/dashboard");
      } else {
        toast.error(response.message);
        navigator("/");
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.message ||
        error?.message ||
        "Something went wrong!";
      toast.error(errMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="container-scroller">
        <div className="container-fluid page-body-wrapper full-page-wrapper">
          <div className="content-wrapper pd-top d-flex align-items-center auth">
            <div className="row flex-grow">
              <div className="col-lg-5 mx-auto">
                <div className="auth-form-light text-left p-4">
                  <div className="brand-logo text-center">
                    <img src="../../images/sb-logo.png" alt="Logo_img" />
                  </div>
                  {/* <h4 className="text-start">Sign In to Your Sarees Bazaar Panel</h4>
                  <p>Enter your email & password to login</p> */}
                  <form onSubmit={handleSubmit}>
                    <div className="form-group">
                      <input
                        type="email"
                        className="form-control form-control-sm"
                        id="email"
                        name="email"
                        placeholder="Email"
                        value={data.email}
                        onChange={handleChange}
                      />
                      {errors.email && (
                        <p className="text-danger">{errors.email}</p>
                      )}
                    </div>
                    <div className="form-group">
                      <div className="input-group">
                        <input
                          type={showPassword ? "text" : "password"}
                          className="form-control form-control-sm"
                          id="password"
                          name="password"
                          placeholder="Password"
                          value={data.password}
                          onChange={handleChange}
                        />
                        <div className="input-group-append">
                          <span
                            className="input-group-text"
                            onClick={() => setShowPassword(!showPassword)}
                            style={{ cursor: "pointer" }}
                          >
                            {showPassword ? <FaEyeSlash /> : <FaEye />}
                          </span>
                        </div>
                      </div>
                      {errors.password && (
                        <p className="text-danger">{errors.password}</p>
                      )}
                    </div>
                    <div className="mt-3">
                      <button
                        type="submit"
                        className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn"
                        disabled={loading}
                      >
                        {loading ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm me-2 mx-1"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            Signing in...
                          </>
                        ) : (
                          "SIGN IN"
                        )}
                      </button>

                    </div>
                    {/* <div className="my-2 text-right">
                      <Link
                        to="/forgot-password"
                        className="auth-link text-black "
                      >
                        Forgot password?
                      </Link>
                    </div> */}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
